import { render, staticRenderFns } from "./TratamientosHojaDiagnostico.vue?vue&type=template&id=13b590e1&scoped=true"
import script from "./TratamientosHojaDiagnostico.vue?vue&type=script&lang=js"
export * from "./TratamientosHojaDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./TratamientosHojaDiagnostico.vue?vue&type=style&index=0&id=13b590e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b590e1",
  null
  
)

export default component.exports